import { css, cva } from '@/styled-system/css';

/**
 * Panel scroller — responsive stacking surface.
 *
 * Mobile: flex column in normal document flow (body scrolls → Safari chrome minimizes).
 * Desktop: absolute-positioned scroller stacked inside the sidebar.
 *
 * isVisible: false
 *   Mobile: display:none removes the panel from the flow entirely.
 *   Desktop: visibility:hidden preserves scroll position within the sidebar.
 */
export const panelScroller = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 'zIndexOverlay',
    background: 'bg.neutral',
    minHeight: '100vh',
    '@supports (min-height: 100dvh)': {
      minHeight: '100dvh',
    },
    md: {
      display: 'block',
      position: 'absolute',

      inset: 0,
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      zIndex: 'zIndexOverParent',
      minHeight: 'unset',
    },
  },
  variants: {
    isVisible: {
      true: {
        visibility: 'visible',
        pointerEvents: 'auto',
      },
      false: {
        display: 'none',
        md: {
          display: 'block',
          visibility: 'hidden',
          pointerEvents: 'none',
        },
      },
    },
  },
  defaultVariants: {
    isVisible: true,
  },
});

/**
 * Non-scrolling backdrop behind the panel stack.
 * Only needed on desktop where panels overlay the sidebar content.
 * On mobile, panels replace the page content in normal flow — no backdrop needed.
 */
export const panelBackdrop = css({
  display: 'none',
  md: {
    display: 'block',
    position: 'absolute',

    inset: 0,
    zIndex: 'zIndexOverParent',
    background: 'bg.neutral',
    pointerEvents: 'none',
  },
});
